import type { ILogTransport } from '../types';

export const createVerboseTransport = (): ILogTransport => ({
  push(event) {
    console.info('[remote log]', event);
  },
});
